import { ClipLoader } from "react-spinners";

export const Loader = () => {
  return (
    <div>
     <ClipLoader color="#73B734" size={50} />
    </div>
  );
};
